import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeader } from "../site/Reveal";
import { linkLabel } from "../../content/siteLinks";

export default function RelatedLinks({ paths, testId = "related-links" }) {
  return (
    <section data-testid={testId} className="py-20 lg:py-24 bg-ivory border-t border-navy/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHeader overline="Keep Exploring" title={<>Related <em className="italic font-medium">services.</em></>} />
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {paths.map((path, i) => (
            <Reveal key={path} delay={i * 0.08}>
              <Link
                to={path}
                data-testid={`related-link-${path.slice(1)}`}
                className="group flex items-center justify-between gap-4 rounded-xl border border-navy/15 bg-cream px-6 py-5 transition-colors duration-300 hover:bg-navy hover:text-ivory"
              >
                <span className="font-display text-lg text-navy transition-colors duration-300 group-hover:text-ivory">{linkLabel(path)}</span>
                <ArrowRight size={16} strokeWidth={1.5} className="shrink-0 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
